import styled from 'styled-components';

const Container = styled.div`
  max-width: 700px;
  border-radius: 4px;
  background-color: #FFF;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin: 80px auto;

  h1 {
    color: #333;
    display: flex;
    flex-direction: row;
    align-items: center;

    svg {
      margin-right: 10px;
    }
  }
`;

export default Container;
